export const MAP_SETTINGS_HEATMAP_UPDATE_TOOLSTATE_DATA = 'MAP_SETTINGS_HEATMAP_UPDATE_TOOLSTATE_DATA';
